module.exports = __webpack_public_path__ + "static/media/v10m.db608843.mp4";